










import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { quillEditor, Quill } from 'vue-quill-editor';
import 'quill/dist/quill.snow.css';
import { deltaToMarkdown } from 'quill-delta-to-markdown';
import TurndownService from 'turndown';
import showdown from 'showdown';
import markdownToQuill from 'markdown-to-quill-delta';

@Component({
    components: {
        quillEditor
    }
})
export default class QuillEditor extends Vue {
    @Prop({ default: '' })
    placeholder: string;
    @Prop({ default: '' })
    // 是 markdown 的 defaultValue
    defaultValue: string;
    @Prop({ default: '' })
    action: string;
    @Prop({ default: false })
    disabled: Boolean;
    markdownContent: string = '';
    editorValue: string = '';
    editorOption: any;
    turndownService: any;
    markdownConverter: any;

    created() {
        // 初始化转换器
        this.turndownService = new TurndownService({
            headingStyle: 'atx',
            codeBlockStyle: 'fenced'
        });

        this.markdownConverter = new showdown.Converter({
            tables: true,
            tasklists: true,
            strikethrough: true
        });

        this.editorOption = {
            markdownContent: '',
            modules: {
                toolbar: {
                    container: [['link']]
                }
            },
            theme: 'snow',
            placeholder: this.placeholder,
            turndownService: null,
            markdownConverter: null
        };
    }

    @Watch('disabled')
    onDisabledChange(val) {
        console.log('onDisabledChange', val);
        if (this.$refs.quillEditor) {
            (this.$refs.quillEditor as any).quill.enable(!val);
        }
    }

    mounted() {
        if (this.markdownContent !== this.defaultValue) {
            this.initFromMarkdown(this.defaultValue);
        }
    }

    @Watch('defaultValue')
    onDefaultValueChanged(val) {
        // console.log('onDefaultValueChanged', val);
        // this.editorValue = val;
    }
    @Watch('editorValue')
    /**
     * emit input and deltaChange event when quill editor's value changes
     * @param val new value
     */
    onEditorValueChanged(val) {
        console.log('onEditorValueChanged', val);
    }

    initFromMarkdown(markdownText) {
        console.log('init', markdownText);
        if (!markdownText) return;

        // 将 Markdown 转换为 Quill Delta
        const delta = markdownToQuill(markdownText);

        // 设置编辑器内容
        (this.$refs.quillEditor as any).quill.setContents(delta);
    }

    // 保存为 Markdown
    saveAsMarkdown() {
        // 获取编辑器的 Delta 内容
        const delta = (this.$refs.quillEditor as any).quill.getContents();

        // 将 Delta 转换为 Markdown
        const markdown = deltaToMarkdown(delta);

        this.markdownContent = markdown;
        return markdown;
    }

    // 编辑器内容变化时的处理
    onEditorChange({ html, text, quill }) {
        // 实时转换为 Markdown
        this.markdownContent = this.turndownService.turndown(html);
        this.$emit('input', this.markdownContent); // 支持 v-model
    }
}
